
import SpeedkitPicture from '#speedkit/components/SpeedkitPicture'

export default {
  name: 'logo-cloud',
  components: { SpeedkitPicture },
  props: {
    light: {
      type: Boolean,
      required: false,
    },
    text: {
      type: String,
      required: false,
    },
  },
}
